module.exports = __webpack_public_path__ + "img/egg.2bd21e4e.svg";